export default [
	'N',
	'NN',
	'NNN',
	'Ground',
	'Gross',
	'Modified Gross',
	'Vacant',
	'Other',
];